/* eslint-disable global-require */
/* eslint-disable max-len */
/**
 * home页配置
 */
export default {
  // 通用导航
  header: {
    banner: {
      title: 'Think Academy US',
      description: 'Think Academy, a TAL Education Group brand, provides world class online teaching services for students grades K - Middle School.',
      buttonName: 'Watch Video',
      videoUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/common/video.mp4',
      className: 'us-index-banner',
      customBtnName: '',
    },
  },

  bannerList: [
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/home/1-spring-class.jpg',
      url: '/1-to-1-assessment',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/home/amc8-banner.jpg',
      url: 'https://www.thethinkacademy.com/blog/think-academys-amc-8-achievements/',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/home/2-our-teachers.jpg',
      url: '/teachers',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/home/3-dual-teachers.jpg',
      url: '/1-to-1-assessment',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/home/4-hot-courses.jpg',
      url: '/courses',
      target: '',
    },
  ],

  // 首页跳转免费课
  selectGrade: {
    titleOneLine: 'Find the right programme for your child',
    placeholder: 'Choose School Year',
    btnText: 'View courses',
  },
  getNotifiedConfig: {
    title: 'Can\'t Find an Appropriate Course for Your Child?',
    // eslint-disable-next-line max-len
    description: 'That\'s ok! While you take some time to think, leave your email with us to receive admissions support for grammar and independent school entry, links to 11+ webinars and more practice materials.',
    form: {
      grade: 'Child\'s Year group',
      firstName: 'Child\'s first name',
      lastName: 'Last name',
      email: 'Your email',
      platform: 'How did you find out about us?',
    },
    notice: 'Sign up for our mailing list to receive the latest news, promotions and updates! ',
    submit: 'Submit',
    success: 'Thank you for your interest in Think Academy!',

  },
  // 数据比例
  dataProportion: {
    title: 'Provides top quality teaching to millions of students worldwide',
  },

  // 教师轮播图
  teacherCarousel: {
    title: 'Experienced teachers from Top U.S Universities',
    description: 'Our team of exceptional Think Academy teachers are hand-picked via a rigorous selection process that has a passing rate of 2.0%. All hold degrees from Top U.S Unversities, including Yale, Standford, Columbia, University of Pennsylvania, and many more. ',
  },

  // 核心优势
  coreAdvantages: {
    title: 'Why Choose Think Academy U.S.',
    advantages: [
      {
        name: 'Scientific Curriculum Design',
        description: 'Think Academy firmly believes in the importance of scientific learning methods and personalized education for children, our content development team aims to provide suitable learning material and place students in classes that are evenly matched with their current learning level and goals.',
        picture: require('assets/images/index/quality-focussed-icon.png'),
      },
      {
        name: 'In-Class and Out-Class Learning Module',
        description: 'Think Academy brings a problem-solving approach to "in-class" learning, helping students to engage and participate；"Out-class" office hour in the long-term courses further helps to solve homework and provide learning assurance.',
        picture: require('assets/images/index/goal-oriented-icon.png'),
      },
      {
        name: 'Experienced Teachers from Top U.S Universities',
        description: 'Think Academy exeptional teachers are hand-picked via a rigorous selection process that has a passing rate of 2.0%. All hold degrees from Top U.S Universities, including Yale, Standford, Columbia, University of Pennsylvania, and many more.',
        picture: require('assets/images/index/technology-driven-icon.png'),
      },
      {
        name: 'Engaging Learning Platform Advancing Learning Interest',
        description: 'Think Academy student centered learning platform providing mini electronic prize to accompliment student\'s engagement and the learning report will help to check student\'s learning progress and the performance.',
        picture: require('assets/images/index/affordable-learning-icon.png'),
      },
    ],
  },

  // 美分-项目介绍
  ourPrograms: {
    title: 'Our Programs',
    listData: [
      {
        imgClass: 'us-accelerated-math',
        picture: require('assets/images/index/us/accelerated-math.jpg'),
        title: 'Accelerated Math',
        description: 'Think Academy’s accelerated long-term math classes are designed to ensure that students excel in both their respective school courses and in math competitions.',
      },
      {
        imgClass: 'us-chinese-learning',
        picture: require('assets/images/index/us/chinese-learning.jpg'),
        title: ' Contest Prep',
        description: 'Our well-rounded contest prep classes provide K12 students with full array of national math contests level from Math Kangaroo to American Mathematics Competitions (AMC 8/10/12) Series.',
      },
      {
        imgClass: 'us-trial-class',
        picture: require('assets/images/index/us/trial-class.jpg'),
        title: 'Trial Class',
        description: ' New to Think Academy? Receive the full Think Academy experience in our trial class, learn online with their peers, play virtual learning games, and more!',
      },
    ],
  },

  // 双师规模
  teacherOnlineInstruction: {
    title: 'Dual-Teacher Online Instruction',
    subtitle: 'In our innovative dual-teacher method , two education experts are assigned to a single class so students can easily receive the one-on-one teaching they need to fully understand each lesson.  ',
    remark: 'Our Dual-Teacher online instruction is currently only available for Grade 2 and Grade 3 courses.',
    tutor: {
      name: 'Content Teacher',
      description: 'Think Academy highly trained professional content teachers deliver core class material and concept, ensuring class interaction.',
    },
    assistant: {
      name: 'Local Teacher',
      description: 'Think Academy local teachers pay attention to individual student learning progress, follow up pre-and after class to ensure the understanding of learning.',
    },
  },

  // 教学效果
  teachingEffect: {
    title: 'What makes Think Academy so Effective?',
    description: 'Our lessons and teaching methods are unique, effective and engaging. With over <span>17</span> years’ experience and over <span>900,000+</span> questions under our belt, we know exactly what is required to deliver online teaching to the highest standard.',
  },

  // 教学环节
  teachingSession: {
    title: 'Think Academy Student Experience',
    sessionList: [{
      title: 'Free 1-on-1 Evaluation',
      description: '',
      picture: require('assets/images/index/student-experience-1-us.jpg'),
    }, {
      title: 'Interactive Lessons',
      description: '',
      picture: require('assets/images/index/student-experience-2-uk.jpg'),
    }, {
      title: 'Lesson Summaries & Reviews',
      description: '',
      picture: require('assets/images/index/student-experience-3-uk.jpg'),
    }, {
      title: 'Homework Assignment & Daily Practice',
      description: '',
      picture: require('assets/images/index/student-experience-4-uk.jpg'),
    }, {
      title: 'Corrections & Academic Feedback',
      description: '',
      picture: require('assets/images/index/student-experience-5-uk.jpg'),
    }, {
      title: 'Teacher Communications',
      description: '',
      picture: require('assets/images/index/student-experience-6-us.jpg'),
    }],
  },

  // 服务
  service: {
    title: 'What we provide',
    serviceList: [{
      title: 'Parent Sit-in Welcomed',
      description: '',
    }, {
      title: 'Interactive Platform',
      description: '',
    }, {
      title: 'Unlimited Lesson Playback',
      description: '',
    }, {
      title: 'Progress and Achievement Tracking Report',
      description: '',
    }, {
      title: 'Flexible Session Transfer',
      description: '',
    }, {
      title: 'One-Click Refund Policy',
      description: '',
    }],
  },

  // 品牌介绍
  brandEndorsement: {
    title: 'Think Academy, first oversea branch of TAL Education Group',
    description: `
      <p>TAL is dedicated to education, with over 17 years of experience. TAL Founded in 2003, Tomorrow Advancing Life was listed on the New York Stock Exchange (NYSE:TAL) in October 2010, becoming the first Chinese education institution for primary and middle school students to be listed in the United States.</p>
      <p>TAL is a leading education and technology enterprise in China, whose core goals are being technology-driven, talent-centred, and quality-focused. Since its establishment, TAL has been committed to integrating technologies and the Internet into education, to deliver a better learning experience for students.</p>
    `,
  },
}
